import gql from 'graphql-tag';

export const ListReleasesQuery = gql`
  query($filter: JSON) {
    Releases(sort: [["date", "asc"], ["orderPriority", "desc"]], filter: $filter) {
      _id
      title
      date
      hasUnknownDay
      featured
      colorway
      nickname
      price
      orderPriority
      searchString
      imageUrls
      isDeleted
      updatedAt
      createdAt
    }
  }
`;

export const ReleaseDetailsQuery = gql`
  query($id: String!) {
    Release(filter:{_id: $id}) {
      _id
      title
      description
      date
      hasUnknownDay
      featured
      colorway
      nickname
      price
      orderPriority
      searchString
      imageUrls
      resellUrls
      comments {
        items {
          _id
          subject_id
          message
          author {
            username
            image
          }
        }
      }
      tag {
        _id
      }
      brand {
        _id
      }
      sneakerModel {
        _id
      }
      buyLinks {
        _id
        link
        title
      }
      raffleLinks {
        raffleId
        link
      }
    }
    ModelBrands {
      _id
      title
    }
    ModelTags {
      _id
      title
    }
    SneakerModels(filter: { isDeleted: null }) {
      _id
      name
      isDeleted
    }
    Raffles {
      _id
      name
    }
  }
`;

export const CreateReleaseFormOptionsQuery = gql`
  {
    ModelBrands {
      _id
      title
    }
    ModelTags {
      _id
      title
    }
    SneakerModels(filter: { isDeleted: null }) {
      _id
      name
      isDeleted
    }
    Raffles {
      _id
      name
    }
  }
`;

export const CreateReleaseMutation = gql`
  mutation($record: JSON) {
    createRelease(record: $record) {
      _id
    }
  }
`;

export const UpdateReleaseMutation = gql`
  mutation($id: String!, $update: JSON) {
    updateRelease(filter: {_id: $id}, update: $update) {
      _id
      title
      date
      hasUnknownDay
      featured
      colorway
      nickname
      price
      orderPriority
      imageUrls
      isDeleted
    }
  }
`;

export const UpdateCommentMutation = gql`
  mutation($id: String!, $update: JSON) {
    updateComment(filter: {_id: $id}, update: $update) {
      _id
      subject_id
      message
    }
  }
`;

export const DeleteReleaseMutation = gql`
  mutation($id: String!) {
    deleteRelease(query: {_id: $id})
  }
`;

export const DeleteCommentMutation = gql`
  mutation($id: String!) {
    deleteComment(query: {_id: $id})
  }
`;

export const CreateModelTagMutation = gql`
  mutation($keyword: JSON) {
    createModelTag(record: $keyword) {
      _id
      title
    }
  }
`;